'use client';

import type { ColumnDef } from '@tanstack/react-table';
import type { EnvVarWithId } from 'enteties/env-variables/model';
import { ArrowUpDown, Check, X } from 'lucide-react';
import { EnvVarActions } from 'widgets/env-var-data-table/ui/env-var-actions';
import { Button } from '@/shared/ui/button';
import * as m from '@paraglide/messages';
export const columns = (slug: string): ColumnDef<EnvVarWithId>[] => [{
  accessorKey: 'name',
  header: ({
    column
  }) => {
    return <Button className="p-0" variant="ghost" onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}>
          {m.tab_envvars_table_column_name()}
          <ArrowUpDown className="ml-2 size-4" />
        </Button>;
  }
}, {
  accessorKey: 'value',
  header: m.tab_envvars_table_column_value(),
  cell: ({
    row
  }) => {
    return <div>{row.original.isSecret ? '********' : row.original.value}</div>;
  }
}, {
  accessorKey: 'isSecret',
  header: m.tab_envvars_table_column_secret(),
  meta: {
    headerClassName: 'w-[110px]' // min-width, taking
  },
  cell: ({
    row
  }) => {
    return <div className="grid place-items-center">
          {row.original.isSecret ? <Check size={17} className="text-status-success" /> : <X size={17} className="text-status-error" />}
        </div>;
  }
}, {
  id: 'actions',
  meta: {
    headerClassName: 'w-[50px] sm:w-[100px]' // min-width, taking
  },
  cell: ({
    row
  }) => <EnvVarActions defaults={row.original} slug={slug} />
}];